module.exports = __webpack_public_path__ + "img/photo-nrg2.1578f1f9.jpg";